import { Box, Button, Grid, Modal } from "@mui/material";
import { Formik } from "formik";
import React, { useEffect, useState } from "react";
import { object, string } from "yup";

import { useMutation } from "react-query";
import MaterialTextFieldComponent from "../../../components/textField/MaterialTextFieldCmp";
// import { ChildOrSibling } from "./sortableTreeCmp";
import { v4 as uuid } from "uuid";
import DropdownCmp2 from "../../../components/dropdown/DropdownCmp2";
import { AddMenu, EditMenu } from "../../../services/menu.service";

type ChildOrSibling = "child" | "sibling" | "update" | "firstTime";
const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: "400px",
  },

  maxHeight: "70vh",
  // minHeight: "30vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  // overflow: "auto",
  // overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "4vh",
  // direction: "ltr",
  borderRadius: "5px",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

interface Props {
  setOpenAddCategory: any;
  openAddCategory: boolean;
  addNodeCild?: any;
  addNodeSibling?: any;
  updateNode?: any;
  rowInfo?: any;
  childOrSibling?: ChildOrSibling;
  setFirstTimeView?: any;
  setUpdateTree?: any;
  permissionOption: any;
  applicationId: string;
  setSearchQuery: any;
  setSearchById: any;
}

const SetNewMenuModal = ({
  setOpenAddCategory,
  openAddCategory,
  rowInfo,
  childOrSibling,
  setFirstTimeView,
  setUpdateTree,
  permissionOption,
  applicationId,
  setSearchQuery,
  setSearchById,
}: Props) => {
  const [isActive, setActivtion] = useState(false);
  const [permissionValue, setPermissionValue] = useState<number>();

  const addNewCategoryInit = {
    title: childOrSibling === "update" ? rowInfo?.node.title : "",
    icon: childOrSibling === "update" ? rowInfo?.node.icon : "",
    // name: childOrSibling === "update" ? rowInfo?.node.name : "",
    route: childOrSibling === "update" ? rowInfo?.node.route : "",
  };
  const addNewCategoryValidation = object().shape({
    title: string()
      .ensure()
      .required("لطفا عنوان منو را وارد نمایید")
      .max(100, "عنوان منو نباید بیش از 100 کاراکتر یاشد"),
    icon: string()
      .ensure()
      .required("لطفا عنوان آیکون را وارد نمایید")
      .max(100, "عنوان آیکون نباید بیش از 100 کاراکتر یاشد"),
    // name: string()
    //   .ensure()
    //   .required("لطفا عنوان انگلیسی را وارد نمایید")
    //   .max(100, "عنوان انگلیسی نباید بیش از 100 کاراکتر یاشد"),
    route: string()
      .ensure()
      .required("لطفا مسیر دسترسی را وارد نمایید")
      .max(100, "مسیر دسترسی نباید بیش از 100 کاراکتر یاشد"),
  });

  const { mutate: AddMenuMutate } = useMutation(AddMenu, {
    onSuccess: (data: { id: number }) => {
      if (data) {
        // DATA STORE IN STATE
        setSearchById(true);
        setSearchQuery(rowInfo.node.id);
        setUpdateTree(uuid());
        setFirstTimeView(false);
      }
    },
    onError: () => {},
  });
  const { mutate: EditMenuMutate } = useMutation(EditMenu, {
    onSuccess: (data: boolean) => {
      if (data) {
        // DATA STORE IN STATE
        setSearchById(true);
        setSearchQuery(rowInfo.node.id);
        setUpdateTree(uuid());
        setFirstTimeView(false);
      }
    },
    onError: () => {},
  });

  useEffect(() => {
    if (openAddCategory) {
      if (childOrSibling === "update") {
        setPermissionValue(rowInfo?.node?.permissionId);
      }
    }
  }, [openAddCategory]);

  const handleSelectedDrop = (e: any) => {
    setPermissionValue(e.target.value);
  };

  const handleAddCategory = (values: any) => {
    if (childOrSibling !== "update") {
      AddMenuMutate({
        // name: values.name,
        parentMenuId:
          childOrSibling === "sibling"
            ? rowInfo.parentNode === undefined
              ? null
              : rowInfo.parentNode.id
            : rowInfo.node.id,
        title: values.title,
        icon: values.icon,
        applicationId:
          rowInfo.node.applicationId === undefined
            ? applicationId
            : rowInfo.node.applicationId,
        permissionId: permissionValue!,
        route: values.route,
      });
    } else {
      EditMenuMutate({
        // name: values.name,
        title: values.title,
        id: rowInfo.node.id,
        parentMenuId: rowInfo.node.parentMenuId,
        icon: values.icon,
        applicationId: rowInfo.node.applicationId,
        permissionId: permissionValue!,
        route: values.route,
      });
    }
    setOpenAddCategory(false);
    setActivtion(false);
  };

  return (
    <div>
      <Modal
        open={openAddCategory}
        onClose={() => {
          setOpenAddCategory(false);
          setPermissionValue(undefined);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={deactiveUserStyle}>
          <Grid
            container
            flexDirection={"column"}
            justifyContent={"space-between"}
            alignItems={"center"}
            gap={"3.8rem"}
          >
            <Grid item width={"100%"}>
              <Formik
                initialValues={addNewCategoryInit}
                onSubmit={handleAddCategory}
                validateOnMount={true}
                validationSchema={addNewCategoryValidation}
              >
                {({
                  handleSubmit,
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Grid
                      container
                      flexDirection={"column"}
                      gap={"15px"}
                      width={"100%"}
                    >
                      <Grid item marginBottom={"20px"}>
                        <MaterialTextFieldComponent
                          placeHolder={"عنوان منو"}
                          label={"عنوان منو"}
                          required={true}
                          name={"title"}
                          id={"title"}
                          autoFocus={true}
                          helperText={touched.title ? errors.title : ""}
                          error={touched.title && Boolean(errors.title)}
                          value={values.title}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                      </Grid>
                      {/* <Grid item marginBottom={"20px"}>
                        <MaterialTextFieldComponent
                          placeHolder={"عنوان انگلیسی منو"}
                          label={"عنوان انگلیسی منو"}
                          required={true}
                          name={"name"}
                          id={"name"}
                          helperText={touched.name ? errors.name : ""}
                          error={touched.name && Boolean(errors.name)}
                          value={values.name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onKeyDown={(e) => {
                            if (
                              /^[آ-ی ء چ]+$/.test(e.key) &&
                              e.code !== "Space"
                            ) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Grid> */}
                      <Grid
                        item
                        marginBottom={"20px"}
                        className="dropdownCmp2-container"
                      >
                        <DropdownCmp2
                          style={{
                            paddingRight: "0 !important",
                            maxWidth: "400px",
                          }}
                          onChange={handleSelectedDrop}
                          value={permissionValue}
                          label={"عنوان دسترسی*"}
                          options={permissionOption}
                          name="permission"
                          id="permission"
                        />
                      </Grid>
                      <Grid item marginBottom={"20px"}>
                        <MaterialTextFieldComponent
                          placeHolder={"مسیر دسترسی"}
                          label={"مسیر دسترسی"}
                          required={true}
                          name={"route"}
                          id={"route"}
                          helperText={touched.route ? errors.route : ""}
                          error={touched.route && Boolean(errors.route)}
                          value={values.route}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onKeyDown={(e) => {
                            if (
                              /^[آ-ی ء چ]+$/.test(e.key) &&
                              e.code !== "Space"
                            ) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Grid>
                      <Grid item marginBottom={"20px"}>
                        <MaterialTextFieldComponent
                          placeHolder={"عنوان آیکون"}
                          label={"عنوان آیکون"}
                          required={true}
                          name={"icon"}
                          id={"icon"}
                          helperText={touched.icon ? errors.icon : ""}
                          error={touched.icon && Boolean(errors.icon)}
                          value={values.icon}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          onKeyDown={(e) => {
                            if (
                              /^[آ-ی ء چ]+$/.test(e.key) &&
                              e.code !== "Space"
                            ) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </Grid>

                      <Grid item width={"100%"}>
                        <Grid
                          container
                          flexDirection={"row"}
                          justifyContent={"space-between"}
                          gap={{ xs: "1rem", md: "unset" }}
                        >
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={6}
                            maxWidth={{ xs: "unset", md: "160px !important" }}
                          >
                            <Button
                              fullWidth
                              variant="contained"
                              type="submit"
                              disabled={
                                !values.title ||
                                // || !values.name
                                !values.icon
                              }
                              className={
                                !values.title ||
                                // || !values.name
                                !values.icon
                                  ? "btnForm disabledBtn"
                                  : "btnForm SuccessDefault"
                              }
                            >
                              تایید و ادامه
                            </Button>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            sm={12}
                            md={12}
                            lg={6}
                            maxWidth={{ xs: "unset", md: "160px !important" }}
                          >
                            <Button
                              fullWidth
                              variant="contained"
                              style={{
                                fontSize: "1rem",
                                color: "#fff",
                                height: "40px",
                                background: "#607D8B",
                              }}
                              onClick={() => {
                                setOpenAddCategory(false);
                                setPermissionValue(undefined);
                              }}
                            >
                              بازگشت
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </form>
                )}
              </Formik>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
};

export default SetNewMenuModal;
